import React, { useState } from 'react';
import {
  Box,
  Text,
  SimpleGrid,
  Image,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  useDisclosure,
  VStack,
} from '@chakra-ui/react';

import Navbar from '../Components/Navbar';

function FAQ() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedTab, setSelectedTab] = useState(null);

  const faqTabs = [
    {
      Title: 'What is Jump Finance and where is it from?',
      children: (
        <Text>
          Jump Finance is a technology company that helps students at the University of the Gambia
          finance their tuition to continue their post-secondary studies. It is based out of Austin,
          TX in the United States and Banjul, The Gambia.
        </Text>
      ),
    },
    {
      Title: 'Who is Jump Finance for?',
      children: (
        <Text>
          Students studying at the Gambia University who need a way to finance their higher
          education.
        </Text>
      ),
    },
    {
      Title: 'How long does the application process last?',
      children: (
        <Text>
          The length of the application process depends on you. If you are proactive and quickly
          provide required documentation, take required assessments, verify your information with a
          Jump Finance representative in a small interview, the process will move quicker. Most
          applicants can comfortably complete the process within 2-3 days.
        </Text>
      ),
    },
    {
      Title: 'What documents do I need to qualify for a tuition advance?',
      children: (
        <>
          <Text>
            To qualify for a tuition advance you need to be 18+ years old, be studying at the
            University of The Gambia (UTG) and submit the following:
          </Text>
          <ul>
            <li>Proof of Identity (National ID, Passport, or Birth Certificate)</li>
            <li>Academic Transcript Summary Page from UTG Portal showing GPA</li>
            <li>UTG Invoice from Office of Director of Finance</li>
          </ul>
        </>
      ),
    },
    {
      Title: 'What does the application process look like?',
      children: (
        <>
          <Text>Four quick steps to receiving a Jump Finance tuition advance:</Text>
          <ol>
            <li>Application with document submission</li>
            <li>
              Verify your information with a Jump Finance representative (we will reach out to you
              within 3 days)
            </li>
            <li>E-sign your tuition agreement</li>
            <li>Pay your application fee (10% of your first tuition advance)</li>
          </ol>
          <Text>
            Once you complete these steps, you are officially enrolled with Jump Finance.
          </Text>
        </>
      ),
    },
    {
      Title: 'Do I need collateral or a guarantor?',
      children: (
        <Text>You do not need collateral or a guarantor to apply for a tuition advance.</Text>
      ),
    },
    {
      Title: 'What are the fees?',
      children: (
        <>
          <ul>
            <li>Application Fee: One-time fee on first tuition advance of 10% of the advance</li>
            <li>Membership Fee during studies: 200 Dalasi monthly</li>
            <li>Membership Fee 6 months after graduating: 400 Dalasi monthly</li>
          </ul>
        </>
      ),
    },
    {
      Title: 'Why does Jump Finance charge fees?',
      children: (
        <Text>
          Jump Finance is a social impact business. To grow sustainably, we must have a source of
          revenue. We aim to provide the lowest rates possible while serving more students.
        </Text>
      ),
    },
    {
      Title: 'What is the minimum repayment?',
      children: (
        <>
          <ul>
            <li>During studies: 1000 Dalasi + 200 Dalasi membership fee</li>
            <li>
              6 months after graduating: 2000 Dalasi + 400 Dalasi membership fee
            </li>
          </ul>
        </>
      ),
    },
    {
      Title: 'Can I pay my tuition advance down faster?',
      children: (
        <Text>
          Of course! You can pay it down as fast as you like. This will reduce fees.
        </Text>
      ),
    },
    {
      Title: 'What day is repayment due?',
      children: (
        <Text>
          Repayment is always due on the 5th of every month. You will receive an invoice and
          reminders.
        </Text>
      ),
    },
    {
      Title: 'Example Tuition Advance',
      children: (
        <>
          <Text>
            Example: Tuition advance of D 18,000 with application fee D 1,800 and membership fees
            depending on repayment period.
          </Text>
        </>
      ),
    },
    {
      Title: 'What happens if I get a scholarship?',
      children: (
        <Text>
          If you receive a scholarship that pays off UTG tuition, you will be released from future
          commitments and refunded tuition advance payments when UTG is paid in full. Application
          and membership fees are non-refundable.
        </Text>
      ),
    },
  ];

  return (
    <div>
      {/* Header */}
      <Box bg="#00D29D" w="100%" h="8vh" display="flex" alignItems="center" justifyContent="center">
        <Text fontSize="16px" fontWeight="semibold" mt="1vh">
          FAQ
        </Text>
      </Box>

      {/* Page Title */}
      <Box p={[2, 4]} mx="auto" maxW="1200px">
        <Text fontWeight="semibold" fontSize="25px" textAlign="center">
          Frequently Asked Questions
        </Text>
      </Box>

      {/* Grid */}
      <SimpleGrid columns={[2, null, 4]} spacing={4} px={[4, 6]} py={4}>
        {faqTabs.map((tab, idx) => (
          <Box
            key={idx}
            bg="#e6fff9"
            boxShadow="md"
            borderRadius="md"
            p={3}
            aspectRatio={2.5}
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            _hover={{ boxShadow: 'lg', cursor: 'pointer' }}
            onClick={() => {
              setSelectedTab(tab);
              onOpen();
            }}
          >
            <Text fontWeight="medium" textAlign="center" fontSize="sm">
              {tab.Title}
            </Text>
          </Box>
        ))}
      </SimpleGrid>

      {/* Modal */}
      <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl" motionPreset="scale">
        <ModalOverlay backdropFilter="blur(8px)" />
        <ModalContent borderRadius="lg" p={2}>
          <ModalHeader fontSize="lg" fontWeight="bold">
            {selectedTab?.Title}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={3} align="start">
              {selectedTab?.children}
            </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>

      {/* Navbar */}
      <Box mt="50px">
        <Navbar />
      </Box>
    </div>
  );
}

export default FAQ;
